
class LazyImage {
    constructor() {
        const images = window.document.querySelectorAll('source, img');
        const backgroundImages = window.document.querySelectorAll('.background-lazy');

        // Some config parameters for the IntersectionObserve
        const config = {
            // If the image gets within 50px in the Y axis, start the download.
            rootMargin: '50px 0px',
            threshold: 0.01
        };

        let observer;

        const onIntersection = (entries) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    // Stop watching and load the image
                    observer.unobserve(entry.target);
                    // call our method: preloadImage
                    if (entry.target.dataset.background) {
                        this.preloadBackgroundImage(entry.target);
                    } else {
                        this.preloadImage(entry.target);
                    }
                }
            });
        };

        // If we don't have support for intersection observer, load the images immediately
        if (!('IntersectionObserver' in window)) {
            images.forEach(image => this.preloadImage(image));
            backgroundImages.forEach(backgroundImage => this.preloadBackgroundImage(backgroundImage));
        } else {
            // It is supported, load the images by calling our method: onIntersection
            observer = new IntersectionObserver(onIntersection, config);
            images.forEach(image => {
                observer.observe(image);
            });

            backgroundImages.forEach(backgroundImage => {
                observer.observe(backgroundImage);
            });
        }

        window.onbeforeprint = (event) => {
            images.forEach(image => this.preloadImage(image));
            backgroundImages.forEach(backgroundImage => this.preloadBackgroundImage(backgroundImage));
        };
    }

    preloadImage(element) {
        if (element.dataset && element.dataset.src) {
            element.src = element.dataset.src;
            if (element.parentNode.parentNode) {
                element.parentNode.parentNode.classList.remove('lazy');
            }
        }
        if (element.dataset && element.dataset.srcset) {
            element.srcset = element.dataset.srcset;
        }
    }

    preloadBackgroundImage(element) {
        if (element.dataset && element.dataset.background) {
            element.style.backgroundImage = `url('${element.dataset.background}')`;
        }
    }
}

export default LazyImage;
